module.exports = __webpack_public_path__ + "src/assets/individualImages/melliferaThreeCorneredHat.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/melliferaThreeCorneredHat.png
// module id = ./src/assets/individualImages/melliferaThreeCorneredHat.png
// module chunks = 0